<template>
    <div class='main'>
        <div class='plugins-tips'>
            <el-row>
                <el-col :span='22'>
                    <el-form ref='queryForm' :inline='true' :model='queryParams' size='small'>
                        <el-form-item label='埋点事件'>
                            <el-select clearable size='mini' v-model='queryParams.eventId' filterable
                                       placeholder='请选择'>
                                <el-option
                                    v-for='item in trackEventList'
                                    :key='item.id'
                                    :label='item.eventName'
                                    :value='item.id'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='事件ID' prop='name'>
                            <el-input
                                v-model='queryParams.name'
                                placeholder='请输入报表名字'
                                clearable
                                size='mini'
                                style='width: 180px'
                                @keyup.enter.native='handleQuery'
                            />
                        </el-form-item>
                        
                        <el-form-item style='margin-bottom: 0'>
                            <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                            </el-button>
                            <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span='2'>
                    <el-button
                        type='primary'
                        plain
                        icon='el-icon-plus'
                        size='mini'
                        @click='handleAdd'
                    >新增事件分析
                    </el-button>
                </el-col>
            </el-row>
        </div>
        
        <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='trackAnalyseReportSettingList'
                  @sort-change='handleSortChange'>
            <el-table-column width='200' show-overflow-tooltip sortable='custom' label='报表名' align='center'
                             prop='name' />
            <el-table-column label='目标事件' align='center' prop='yesterdayCount'>
                <template slot-scope='scope'>
                    <el-link v-if='!scope.row.commonEvent' :underline='false' @click='handleClickTargetEvent(scope.row)' type='primary'>{{ computeEventName(scope.row) }}</el-link>
                </template>
            </el-table-column>
            <el-table-column label='报表类型' align='center' prop='todayCount'>
                <template slot-scope='scope'>
                    <el-tag size='mini' :type="scope.row.commonEvent ? 'danger' : 'success'">{{scope.row.commonEvent ? '通用' : '项目独有'}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label='报表设置' show-overflow-tooltip align='center' prop='todayCount'>
                <template slot-scope='scope'>
                    <el-link @click='clickViewTrackReportSetting(scope.row)' :underline='false' type='primary'>简单查看</el-link>
                </template>
            </el-table-column>
            <el-table-column width='100' label='创建用户' align='center'>
                <template slot-scope='scope'>
                    <span>{{ computeUserAccount(scope.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column sortable='custom' label='创建时间' align='center' prop='createTime' />
            <el-table-column sortable='custom' label='更新时间' align='center' prop='updateTime' />
            <el-table-column
                label='操作'
                align='center'
                width='200'
                class-name='small-padding fixed-width'
            >
                <template slot-scope='scope' v-if='scope.row.userId !== 1'>
                    <el-button
                        size='mini'
                        type='text'
                        icon='el-icon-s-help'
                        @click='handleViewSingle(scope.row)'
                    >查看
                    </el-button>
                    
                    <el-button
                        size='mini'
                        type='text'
                        icon='el-icon-edit'
                        @click='handleUpdate(scope.row)'
                    >修改
                    </el-button>
                    
                    <el-button
                        icon='el-icon-delete'
                        size='mini'
                        type='text'
                        @click='handleDelete(scope.row)'
                    >删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        
        <div class='pagination'>
            <el-pagination
                :current-page='queryParams.pageNum'
                :page-sizes='[15, 30, 45, 60, 75, 100, 200, 300]'
                :page-size='queryParams.pageSize'
                :total='queryParams.total'
                background
                layout='sizes, prev, pager, next'
                @size-change='handleSizeChange'
                @current-change='handlePagination'>
            </el-pagination>
        </div>
        
        <!-- 添加或修改用户配置对话框 -->
        <el-dialog :visible.sync='open' width='40%' @close='cancel'>
            <template slot='title'>
                <el-row>
                    <el-col :span='12'>
                        <span>{{ title }}</span>
                    </el-col>
                    <el-col :span='12'>
                        <el-link href='https://cdn.cottongame.com/docFile/track_analyse.pdf' target='_blank'
                                 type='primary'>事件埋点分析文档
                        </el-link>
                    </el-col>
                </el-row>
            </template>
            <el-tabs :before-leave='handleBeforeLeave' tab-position='left' v-model='trackReportStepTab'>
                <el-tab-pane name='selectEvent' label='选择事件'>
                    <div>
                        <el-select :disabled='updateStatus' @change='handleChangeEvent' clearable size='mini'
                                   v-model='reportSetting.eventId'
                                   filterable placeholder='请选择事件'>
                            <el-option
                                v-for='item in trackEventList'
                                :key='item.id'
                                :label='item.eventName'
                                :value='item.id'>
                            </el-option>
                        </el-select>
                    </div>
                    <div style='margin-top: 1rem;'>
                        <el-button type='primary' v-if='!updateStatus' @click='handleCopyReportSetting'>拷贝报表设置</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane name='dimension' label='维度'>
                    <el-alert
                        style='margin-bottom: 1rem;'
                        title='通过添加指标的分组，分析事件不同维度。例如添加年龄分组，系统会将该事件的所有数据按照年龄进行分组，分组之后，可以查看某个年龄有多少人等。最多支持两个分组。'
                        type='success'
                        :closable='false'>
                    </el-alert>
                    <el-collapse :accordion='false'>
                        <el-card style='margin-bottom: 1rem;'
                                 v-for='(dimensionSetting, index) in reportSetting.dimensionSettingList' :key='index'>
                            <div slot='header' class='clearfix'>
                                <el-row :gutter='20'>
                                    <el-col :span='4'>
                                        <span>{{ dimensionSetting.dimensionTitleDescription ? dimensionSetting.dimensionTitleDescription : '请选择分组'
                                            }}</span>
                                    </el-col>
                                    <el-col :span='12'>
                                        <el-row :gutter='10'>
                                            <el-col :span='12'>
                                                <el-select clearable size='mini' v-model='dimensionSetting.sortType'
                                                           filterable placeholder='分组排序方式'>
                                                    <el-option
                                                        v-for='item in options.dimensionSortTypeOption'
                                                        :key='item.value'
                                                        :label='item.label'
                                                        :value='item.value'>
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span='12'>
                                                <el-select clearable size='mini'
                                                           v-model='dimensionSetting.fieldValueType'
                                                           filterable placeholder='维度字段类型'>
                                                    <el-option
                                                        v-for='item in options.dimensionFieldTypeOption'
                                                        :key='item.value'
                                                        :label='item.label'
                                                        :value='item.value'>
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span='4'>
                                        <el-button style='float: right; padding: 3px 0' type='text'
                                                   @click='removeDimension(index)'>移除
                                        </el-button>
                                    </el-col>
                                </el-row>
                            </div>
                            
                            <el-tabs tab-position='top'>
                                
                                <el-tab-pane :label='dimensionItem.label'
                                             v-for='(dimensionItem, index) in options.chooseDimensionFieldOption'
                                             :key='index'>
                                    分组字段:
                                    <el-select clearable size='mini' v-model='dimensionSetting.argumentField'
                                               @change='handleDimensionArgumentFieldChange(dimensionSetting)'
                                               filterable placeholder='请选择分组字段'>
                                        <el-option
                                            v-for='item in computeDimensionOption(dimensionItem.value)'
                                            :key='item.value'
                                            :label='item.label'
                                            :value='item.value'>
                                        </el-option>
                                    </el-select>
                                </el-tab-pane>
                            </el-tabs>
                        </el-card>
                    </el-collapse>
                    
                    <div v-if='reportSetting.dimensionSettingList.length < 2' style='margin-bottom: 1rem;'>
                        <el-button @click='createNewDimensionSetting' style='float: right; ' type='text'>
                            新增维度
                        </el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane name='metric' label='指标'>
                    <div>
                        <el-alert
                            style='margin-bottom: 1rem;'
                            title='指标用于对分组后的单个分组数据进行计算'
                            type='success'
                            :closable='false'>
                        </el-alert>
                        <el-collapse :accordion='false' >
                            <el-collapse-item style='margin-bottom: 1rem;' v-for='(item, index) in reportSetting.metricSettingList' :key='index'>
                                <template slot="title">
                                    <el-row :gutter='30'>
                                        <el-col :span='2'>
                                            <el-tag>{{ item.metricName }}</el-tag>
                                        </el-col>
                                        <el-col :span='18'>
                                            <el-row :gutter='30'>
                                                <el-col :span='10'>
                                                    <el-input @keyup.enter.stop.native @keyup.space.stop.native
                                                              v-on:click.native.stop v-model='item.metricTitle'
                                                              placeholder='请输入指标名'></el-input>
                                                </el-col>
                                                <el-col :span='14'>
                                                    <el-row :gutter='20'>
                                                        <el-col :span='12'>
                                                            <el-select v-model='item.maximumFractionDigits'
                                                                       placeholder='请选择小数点位数'>
                                                                <el-option
                                                                    v-for='item in options.maximumFractionDigitsOption'
                                                                    :key='item.value'
                                                                    :label='item.label'
                                                                    :value='item.value'>
                                                                </el-option>
                                                            </el-select>
                                                        </el-col>
                                                        <el-col :span='12'>
                                                            <el-select v-model='item.chartType' placeholder='图表类型'>
                                                                <el-option
                                                                    v-for='item in options.chartTypeOption'
                                                                    :key='item.value'
                                                                    :label='item.label'
                                                                    :value='item.value'>
                                                                </el-option>
                                                            </el-select>
                                                        </el-col>
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                        </el-col>
                                        <el-col :span='4'>
                                            <el-button v-on:click.native.stop @click='removeMetric(index)' type='text'>
                                                移除
                                            </el-button>
                                        </el-col>
                                    </el-row>
                                </template>
                                <div class='formula-box'>
                                    <div class='formula-input' v-if='item.detailFormulaElementMapList.length > 0'>
                                        <span :key='formulaIndex'
                                              v-for='(formulaElement, formulaIndex) in item.detailFormulaElementMapList'>
                                            <span v-if='formulaElement.type !== "inputValue"'
                                                  class='formula-element el-tag'>
                                            {{ formulaElement.variableDescription }}
                                                <span slot='reference' class='formula-filter'
                                                      v-if='formulaElement.supportNumericalFilter'
                                                      @click='handleMetricParameterFilter(item, formulaElement)'><i
                                                    class='el-icon-edit'></i></span>
                                            </span>
                                            <span v-if='formulaElement.type === "inputValue"'
                                                  class='formula-element el-tag'>
                                                <el-input-number v-model='formulaElement.formulaElement' size='mini'
                                                                 controls-position='right'></el-input-number>
                                        </span>
                                    </span>
                                    </div>
                                    <el-row :gutter='30' style='width: 50%;margin-top: 1rem;'>
                                        <el-col :span='12'>
                                            <el-button :disabled='item.detailFormulaElementMapList.length === 0' @click='handleClearFormulaElement(true, item)' size='mini' style='color: #F56C6C' type='text'>清除全部</el-button>
                                        </el-col>
                                        <el-col :span='12'>
                                            <el-button :disabled='item.detailFormulaElementMapList.length === 0' @click='handleClearFormulaElement(false, item)'type='text' size='mini'>清除一个</el-button>
                                        </el-col>
                                    </el-row>
                                </div>
                                
                                <el-row style='margin-top: 1rem;' :gutter='30'>
                                    <el-col :span='8'>
                                        <el-cascader
                                            size='mini'
                                            clearable
                                            ref='cascader'
                                            placeholder='请选择属性'
                                            :options='options.metricFinallyFormulaOption'
                                            @change='handleMetricFormulaChange(item, $event)'></el-cascader>
                                    </el-col>
                                    <el-col :span='8'>
                                        <el-select value='' @change='handleArithmeticOperatorChange(item, $event)' clearable
                                                   size='mini' filterable placeholder='请选择运算符符号'>
                                            <el-option
                                                v-for='item in options.arithmeticOperatorOption'
                                                :key='item.value'
                                                :label='item.label'
                                                :value='item.value'>
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span='8'>
                                        <el-select value='' @change='handleMetricOtherOperatorChange(item, $event)' clearable
                                                   size='mini' filterable placeholder='输入值'>
                                            <el-option
                                                v-for='item in options.metricOtherOption'
                                                :key='item.value'
                                                :label='item.label'
                                                :value='item.value'>
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                    <el-row style='margin-bottom: 1rem;' :gutter='20'>
                        <el-col :span='24'>
                            <el-button @click='createNewMetricSetting' style='float: right; ' type='text'>
                                新增指标
                            </el-button>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane name='globalFilter' label='全局筛选'>
                    <track-data-filter :event-id='reportSetting.eventId'
                                       :condition-config='reportSetting.globalFilterExpress'
                                       tip-message='【可选】这是全局筛选, 进行报表分析时, 会先应用下列条件对查询到的埋点数据进行筛选, 筛选过后的数据才会进行后续的维度及各个指标的分析计算'
                                       @getFilterCondition='handleGlobalFilterCondition' />
                </el-tab-pane>
                <el-tab-pane name='reportSetting' label='报表'>
                    <el-input placeholder='请输入报表名' v-model='reportSetting.name'>
                        <template slot='prepend'>报表名</template>
                    </el-input>
                    <el-button type='primary' @click='handleTestTrackReport' style='margin-top: 1rem;'>测试
                        "{{ reportSetting.name }}" 报表
                    </el-button>
                </el-tab-pane>
            </el-tabs>
            
            <div slot='footer' class='dialog-footer' v-if='trackReportStepTab !== "selectEvent"'>
                <el-button type='primary' @click='submitForm'>保 存</el-button>
                <el-button @click='cancel'>取 消</el-button>
            </div>
            
            <el-dialog
                width="40%"
                title="拷贝报表设置"
                :visible.sync="openCopyReportSettingDialogStatus"
                @close='handleCopyReportClose'
                append-to-body>
                <el-form label-position='left' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                    <el-form-item label='选择项目'>
                        <el-select size='mini' @change='handleCopyReportProjectChange' v-model='copyReportSetting.projectAppId' filterable placeholder='请选择'>
                            <el-option
                                v-for='item in projectInfoList'
                                :key='item.id'
                                :label='item.cnName'
                                :value='item.appId'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='事件'>
                        <el-select size='mini' @change='handleCopyReportEventChange' v-model='copyReportSetting.eventId' filterable placeholder='请选择'>
                            <el-option
                                v-for='item in copyReportSetting.trackEventList'
                                :key='item.id'
                                :label='`${item.eventName} ${item.eventId}`'
                                :value='item.id'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label='报表'>
                        <el-select size='mini' v-model='copyReportSetting.trackReportSettingId' filterable placeholder='请选择'>
                            <el-option
                                v-for='item in copyReportSetting.trackReportSettingList'
                                :key='item.id'
                                :label='item.name'
                                :value='item.id'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item style='margin-bottom: 0'>
                        <el-button :disabled='!copyReportSetting.trackReportSettingId' icon='el-icon-search' size='mini'
                                   type='primary' @click='handleExecuteCopyReportSetting'>拷 贝
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
            
            <el-dialog
                title='条件过滤器'
                :visible.sync='eventDataConditionFilter.open'
                width='40%' append-to-body>
                <track-data-filter :event-id='reportSetting.eventId'
                                   @getFilterCondition='handleGetCondition'
                                   :key='new Date().getTime()'
                                   :tip-message='`将应用下列条件去筛选用于计算 ${eventDataConditionFilter.currentEditFormulaElement.variableDescription} 值的事件数据`'
                                   :condition-config='eventDataConditionFilter.conditionConfig' />
            </el-dialog>
        
        </el-dialog>
        
        
        <el-dialog :title='showTrackReportChart.reportSettingInfo.name'
                   @close='handleCloseTrackReportChart'
                   :visible.sync='showTrackReportChart.openTrackReportDialogStatus' width='70%'>
            <track-event-chart :event-id='queryParams.eventId'
                               :show-time-picker='false'
                               :track-report-setting-json='showTrackReportChart.trackReportSettingJson'
                               :track-report-setting-id='showTrackReportChart.reportSettingInfo.id'
                               :project-app-id='queryParams.projectAppId'/>
        </el-dialog>
    </div>
</template>

<script>

import { pageUtil } from '@/utils/pageUtil';
import { trackReportSettingApi } from '@api/Track/trackReportSetting';
import { selectEmployeeList } from '@api/dashboard';
import { trackEventApi } from '@api/Track/trackEvent';
import { message } from '@/utils/message';
import bus from '@/components/common/bus';
import { trackParameterApi } from '@api/Track/trackParameter';
import { deepCopy } from '@/utils/object';
import { projectInfoApi } from '@api/ProjectInfo';
import TrackEventChart from '@view/track/analyse/component/TrackEventChart.vue';
import TrackDataFilter from '@/components/component/storage/TrackDataFilter.vue';
import { generateSortNextCharacter } from '@/utils/string/cottonPlugin';

export default {
    name: 'User',
    components: { TrackDataFilter, TrackEventChart },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                eventId: undefined,
                projectAppId: undefined,
                name: undefined
            },
            dimensionTypeOption: [
                {
                    label: '内置维度数据',
                    value: 'INTERNAL_DIMENSION'
                },
                {
                    label: '内置维度数据',
                    value: 'EVENT_REPORT_PARAM_FIELD'
                },
                {
                    label: '内置维度数据',
                    value: 'EVENT_DATA_PARAM_FIELD'
                }
            ],
            reportSetting: {
                eventId: undefined,
                name: undefined,
                dimensionSetting: {
                    dimensionTitle: undefined,
                    dimensionTitleDescription: undefined,
                    argumentField: undefined,
                    dimensionType: undefined,
                    dimensionIntervalRangeSet: [],
                    sortType: 'NATURAL',
                    index: undefined
                },
                metricSettingList: [],
                dimensionSettingList: [],
                eventParameterList: [],
                globalFilterExpress: {}
            },
            options: {
                chooseDimensionFieldOption: [
                    {
                        label: '全部',
                        value: 'all'
                    },
                    {
                        label: '事件属性',
                        value: 'event_parameter_field'
                    },
                    {
                        label: '用户属性',
                        value: 'event_internal'
                    },
                    {
                        label: '内置属性',
                        value: 'event_data_param_field'
                    }
                ],
                expressOption: [
                    {
                        label: '大于',
                        value: '>'
                    },
                    {
                        label: '大于等于',
                        value: '>='
                    },
                    {
                        label: '小于',
                        value: '<'
                    },
                    {
                        label: '小于等于',
                        value: '<='
                    },
                    {
                        label: '等于',
                        value: '=='
                    }
                ],
                stringExpressOption: [
                    {
                        label: '等于',
                        value: '=='
                    },
                    {
                        label: '不等于',
                        value: '!='
                    },
                    {
                        label: '为空',
                        value: 'isEmpty'
                    },
                    {
                        label: '不为空',
                        value: 'isNotEmpty'
                    },
                    {
                        label: '开头是',
                        value: 'startWith'
                    },
                    {
                        label: '结尾是',
                        value: 'endsWith'
                    },
                    {
                        label: '包含',
                        value: 'contains'
                    },
                    {
                        label: '不包含',
                        value: 'notContains'
                    }
                ],
                dimensionOption: [
                    {
                        label: '用户标签',
                        value: 'clientTag',
                        parameterType: 'STRING',
                        dimensionType: 'EVENT_DATA_PARAM_FIELD'
                    },
                    {
                        label: '上报时间',
                        value: 'createTime',
                        parameterType: 'STRING',
                        dimensionType: 'EVENT_DATA_PARAM_FIELD'
                    },
                    {
                        label: '操作系统',
                        value: 'operationSystem.name',
                        parameterType: 'STRING',
                        dimensionType: 'INTERNAL_DIMENSION'
                    },
                    {
                        label: '位置: 国家',
                        value: 'requestAddressInfo.country',
                        parameterType: 'STRING',
                        dimensionType: 'INTERNAL_DIMENSION'
                    },
                    {
                        label: '位置: 省份',
                        value: 'requestAddressInfo.province',
                        parameterType: 'STRING',
                        dimensionType: 'INTERNAL_DIMENSION'
                    },
                    {
                        label: '位置: 城市',
                        value: 'requestAddressInfo.city',
                        parameterType: 'STRING',
                        dimensionType: 'INTERNAL_DIMENSION'
                    },
                ],
                metricFinallyFormulaOption: [],
                metricCommonFormulaOption: [
                    {
                        label: '总次数',
                        value: 'INTERNAL_TOTAL_COUNT',
                        applicationType: 'COMMON',
                        category: 'common'
                    },
                    {
                        label: '触发用户数',
                        value: 'INTERNAL_USER_TRIGGER_COUNT',
                        applicationType: 'COMMON',
                        category: 'common'
                    },
                    {
                        label: '人均次数',
                        value: 'INTERNAL_USER_AVERAGE_FREQUENCY_COUNT',
                        applicationType: 'COMMON',
                        category: 'common'
                    }
                ],
                metricNumericalEventParameterFormulaOption: [
                    // 下面的都是和事件相关的
                    {
                        label: '总和',
                        value: 'PARAM_TOTAL_SUM',
                        applicationType: 'INTEGER',
                        category: 'param'
                    },
                    {
                        label: '最大值',
                        value: 'PARAM_MAX_VALUE',
                        applicationType: 'INTEGER',
                        category: 'param'
                    },
                    {
                        label: '最小值',
                        value: 'PARAM_MIN_VALUE',
                        applicationType: 'INTEGER',
                        category: 'param'
                    },
                    {
                        label: '平均值',
                        value: 'PARAM_AVERAGE_VALUE',
                        applicationType: 'INTEGER',
                        category: 'param'
                    },
                    {
                        label: '中位数',
                        value: 'PARAM_MEDIAN_VALUE',
                        applicationType: 'INTEGER',
                        category: 'param'
                    }
                ],
                metricAddictionOption:[
                    {
                        label: '去除重复数据',
                        value: 'INTERNAL_DEDUPLICATION',
                        applicationType: 'COMMON',
                        category: 'param'
                    }
                ],
                arithmeticOperatorOption: [
                    {
                        label: '+',
                        value: '+'
                    },
                    {
                        label: '-',
                        value: '-'
                    },
                    {
                        label: '*',
                        value: '*'
                    },
                    {
                        label: '/',
                        value: '/'
                    },
                    {
                        label: '(',
                        value: '('
                    },
                    {
                        label: ')',
                        value: ')'
                    }
                ],
                metricOtherOption: [
                    {
                        label: '输入数值',
                        value: 'inputNumericalValue',
                        type: 'input'
                    }
                ],
                maximumFractionDigitsOption: [
                    {
                        label: '一位小数',
                        value: 1
                    },
                    {
                        label: '两位小数',
                        value: 2
                    },
                    {
                        label: '三位小数',
                        value: 3
                    },
                    {
                        label: '四位小数',
                        value: 4
                    },
                ],
                chartTypeOption: [
                    {
                        label: '折线图',
                        value: 'line'
                    },
                    {
                        label: '柱状图',
                        value: 'bar'
                    },
                    {
                        label: '饼图',
                        value: 'pie'
                    }
                ],
                dimensionSortTypeOption: [
                    {
                        label: '自然顺序',
                        value: 'NATURAL'
                    },
                    {
                        label: '升序',
                        value: 'ASC'
                    },
                    {
                        label: '降序',
                        value: 'DESC'
                    }
                ],
                dimensionFieldTypeOption: [
                    {
                        label: 'String',
                        value: 'STRING'
                    },
                    {
                        label: 'Number',
                        value: 'NUMBER'
                    },
                    {
                        label: 'Date',
                        value: 'DATE'
                    }
                ]
            },
            adminUserList: [],
            trackAnalyseReportSettingList: [],
            currentTrackAnalyseReportSetting: {},
            trackEventList: [],
            eventMap: new Map,
            adminUserMap: new Map,
            mapTrackerNum: 1,
            projectInfoList: [],
            trackReportStepTab: 'selectEvent',
            tempOptionValue: {
                metric: undefined,
                formulaOperator: undefined
            },
            formulaOptionMap: new Map,
            parameterMap: new Map,
            dimensionOptionMap: new Map,
            popoverOpen: false,
            currentReportSetting: {},
            openCopyReportSettingDialogStatus: false,
            copyReportSetting: {
                projectAppId: undefined,
                eventId: undefined,
                trackReportSettingId: undefined,
                
                trackEventList: [],
                trackReportSettingList: [],
                trackReportSettingMap: new Map
            },
            showTrackReportChart: {
                reportSettingInfo: {
                    id: undefined
                },
                openTrackReportDialogStatus: false,
                trackReportSettingJson: undefined
            },
            cascaderValueTemp: undefined,
            
            eventDataConditionFilter: {
                open: false,
                conditionConfig: {},
                currentEditFormulaElement: {}
            },
            metricConfig: {
                metricNameList: []
            }
        };
    },
    computed: {
        computeEventName() {
            return (data) => {
                let event = this.eventMap.get(parseInt(data.eventId));
                if (!event) {
                    return '未知';
                } else {
                    return event.eventName;
                }
            };
        },
        computeUserAccount() {
            return (data) => {
                let user = this.adminUserMap.get(data.createUserId);
                if (!user) {
                    return '未知';
                } else {
                    return user.nickName;
                }
            };
        },
        computeDimensionOption() {
            return (type) => {
                if (type === 'all') {
                    return this.options.dimensionOption;
                } else if (type === 'event_parameter_field') {
                    return this.options.dimensionOption.filter(t => t.dimensionType === 'EVENT_REPORT_PARAM_FIELD');
                } else if (type === 'event_internal') {
                    return this.options.dimensionOption.filter(t => t.dimensionType === 'INTERNAL_DIMENSION');
                } else if (type === 'event_data_param_field') {
                    return this.options.dimensionOption.filter(t => t.dimensionType === 'EVENT_DATA_PARAM_FIELD');
                }
            };
        }
    },
    created() {
        this.setInitValue();
        this.initData();
        if (this.queryParams.projectAppId) {
            bus.$emit('queriedTrackProjectAppId', this.queryParams.projectAppId);
        }
        
        bus.$on('selectedTrackProjectAppId', this.handleSelectedTrackProjectAppIdEvent);
        this.options.metricCommonFormulaOption.forEach(t => this.formulaOptionMap.set(t.value, t.label));
        this.options.metricNumericalEventParameterFormulaOption.forEach(t => this.formulaOptionMap.set(t.value, t.label));
    },
    beforeDestroy() {
        bus.$off('selectedTrackProjectAppId', this.handleSelectedTrackProjectAppIdEvent)
    },
    methods: {
        setInitValue() {
            this.queryParams.projectAppId = undefined;
            if (this.$route.params.projectAppId && this.$route.params.projectAppId.indexOf('undefined') === -1) {
                this.queryParams.projectAppId = this.$route.params.projectAppId;
            }
            if (!this.queryParams.projectAppId) {
                message.error('请选择项目!');
                return;
            }
            this.getList();
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        initData() {
            this.adminUserMap = new Map;
            this.eventMap = new Map;
            this.trackEventList = [];
            this.projectInfoList = [];
            selectEmployeeList({ pageSize: 10000 }).then(result => {
                this.adminUserList = result.data;
                result.data.forEach(t => {
                    this.adminUserMap.set(t.userId, t);
                    this.mapTrackerNum++;
                });
            });
            
            trackEventApi.queryTrackEvent({
                pageSize: 1000000,
                projectAppId: this.queryParams.projectAppId
            }).then(result => {
                if (result.code === 200) {
                    this.trackEventList = result.data.result;
                    result.data.result.forEach(t => {
                        this.eventMap.set(parseInt(t.id), t);
                        this.mapTrackerNum = this.mapTrackerNum + 1;
                    });
                }
            });
            projectInfoApi.query({pageSize: 100000}).then(result => {
                if (result.code === 200) {
                    this.projectInfoList = result.data.result
                }
            })
            
        },
        getList() {
            this.loading = true;
            this.trackAnalyseReportSettingList = [];
            trackReportSettingApi.query(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.trackAnalyseReportSettingList = result.data.result;
                    this.queryParams.total = result.data.total;
                    this.queryParams.pageNum = result.data.pageNum;
                    this.queryParams.pageSize = result.data.pageSize;
                }
                this.loading = false;
            });
        },
        resetReportSetting() {
            this.reportSetting = {
                eventId: undefined,
                name: undefined,
                dimensionSettingList: [],
                metricSettingList: [],
                eventParameterList: []
            }
            this.trackReportStepTab = 'selectEvent'
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
            this.resetReportSetting()
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                eventId: undefined,
                projectAppId: this.queryParams.projectAppId,
                name: undefined
            }
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '新增事件分析';
            this.updateStatus = false;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentReportSetting = row;
            this.open = true;
            this.updateStatus = true;
            this.title = '修改事件报表设置'
            this.setReportSettingParam(row)
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let obj = this;
            this.$modal.confirm('是否确认删除"' + row.name + '"的数据项？').then(function() {
                return trackReportSettingApi.deleteData(row);
            }).then((result) => {
                if (result.code === 200) {
                    message.success(result.message);
                    obj.getList();
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
            this.packageReportSetting(this.updateOrAddReportSetting)
        },
        updateOrAddReportSetting() {
            if (this.updateStatus) {
                let updateObj = deepCopy(this.reportSetting)
                updateObj.id = this.currentReportSetting.id
                // 修改报表
                trackReportSettingApi.update(updateObj).then(result => {
                    if (result.code === 200) {
                        message.success('报表修改成功!')
                        this.open = false;
                        this.getList();
                        this.resetReportSetting();
                    }
                })
            }else {
                trackReportSettingApi.insert(this.reportSetting).then(result => {
                    if (result.code === 200) {
                        message.success('报表保存成功!')
                        this.open = false;
                        this.getList();
                        this.resetReportSetting();
                    }
                })
            }
        },
        packageReportSetting: function(executeFunction) {
            // 将指标转换成后端需要的数据
            if (this.reportSetting.dimensionSettingList.length === 0) {
                message.error('维度不能为空!');
                return;
            }
            if (this.reportSetting.metricSettingList.length === 0) {
                message.error('指标不能为空!');
                return;
            }
            if (!this.reportSetting.name) {
                message.error('报表名不能为空!');
                return;
            }
            this.reportSetting.trackAnalyseReportSetting = {};
            const metricSettingCheckAndSetPromise = new Promise((resolve, reject) => {
                this.reportSetting.metricSettingList.forEach((t, index) => {
                    let detailFormulaElementMapList = t.detailFormulaElementMapList;
                    if (detailFormulaElementMapList.length === 0) {
                        message.error('指标公式不能为空!');
                        return;
                    }
                    t.formula = '';
                    t.formulaElementList = [];
                    detailFormulaElementMapList.forEach((formulaOption, formulaIndex) => {
                        let type = formulaOption.type;
                        switch (type) {
                            case 'arithmeticOperator':
                                // 是四则运算符
                                t.formula = t.formula + formulaOption.formulaElement + ' ';
                                break;
                            case 'inputValue':
                                t.formula = t.formula + formulaOption.formulaElement + ' ';
                                break;
                            case 'formula':
                                let fieldName = formulaOption.fieldName;
                                let formulaName;
                                let formulaElement = '';
                                if (formulaOption.supportNumericalFilter) {
                                    // 旧版本没有公式
                                    if (formulaOption.conditionalExpression && formulaOption.conditionalExpression.operator) {
                                        formulaOption.conditionalExpressionConfig = {
                                            andOperator: true,
                                            conditionList: [formulaOption.conditionalExpression]
                                        };
                                        formulaName = generateSortNextCharacter(detailFormulaElementMapList[formulaIndex - 1]);
                                    } else {
                                        formulaName = formulaOption.formulaName;
                                    }
                                }
                                let formulaInfo = {
                                    formulaApplyFieldName: fieldName,
                                    conditionExpressName: formulaName
                                };
                                
                                formulaElement = `${formulaOption.formulaElement}${JSON.stringify(formulaInfo)}`;
                                t.formula = t.formula + formulaElement + ' ';
                                t.formulaElementList.push(formulaElement);
                        }
                        
                        if (formulaIndex === detailFormulaElementMapList.length - 1 && index === this.reportSetting.metricSettingList.length - 1) {
                            this.reportSetting.trackAnalyseReportSetting.metricSettingList = this.reportSetting.metricSettingList;
                            resolve();
                        }
                    });
                });
            });
            
            const dimensionSettingCheckAndSetPromise = new Promise((resolve, reject) => {
                const dimensionNameSet = new Set();
                this.reportSetting.dimensionSettingList.forEach((t, index) => {
                    if (!t.argumentField) {
                        message.error('分组字段不能为空!');
                        return;
                    }
                    if (dimensionNameSet.has(t.argumentField)) {
                        message.error('存在相同分组 ' + t.dimensionTitle);
                        return;
                    }
                    dimensionNameSet.add(t.argumentField);
                    if (index === this.reportSetting.dimensionSettingList.length - 1) {
                        
                        this.reportSetting.trackAnalyseReportSetting.dimensionSettingList = this.reportSetting.dimensionSettingList;
                        resolve();
                    }
                });
            });
            
            Promise.all([metricSettingCheckAndSetPromise, dimensionSettingCheckAndSetPromise]).then((results) => {
                this.reportSetting.trackAnalyseReportSetting.globalFilterExpress = this.reportSetting.globalFilterExpress;
                executeFunction();
            });
        },
        handleSelectedTrackProjectAppIdEvent(t) {
            this.queryParams.projectAppId = t;
            this.$router.push(`/trackAnalyse/eventSummary/${t}`);
            this.getList();
            this.initData();
        },
        clickViewTrackReportSetting(data) {
            this.showTrackReportChart.reportSettingInfo = data
            this.showTrackReportChart.openTrackReportDialogStatus = true
        },
        handleBeforeLeave(activeName, oldActiveName) {
            if (activeName === 'selectEvent') {
                return true;
            } else {
                if (!this.reportSetting.eventId) {
                    message.error('请先选择事件!');
                    return false;
                } else {
                    return true;
                }
            }
        },
        setDimensionInfo(fieldName, dimensionSetting) {
            let option = this.dimensionOptionMap.get(fieldName);
            if (!option) {
                return;
            }
            dimensionSetting.dimensionTitle = option.label;
            dimensionSetting.dimensionTitleDescription = option.label;
            dimensionSetting.argumentField = fieldName;
            dimensionSetting.dimensionType = option.dimensionType;
        },
        handleChangeEvent() {
            if (!this.reportSetting.eventId) {
                return;
            }
            
            // 查询所有的事件参数
            this.options.dimensionOption = [
                {
                    label: '用户标签',
                    value: 'clientTag',
                    parameterType: 'STRING',
                    dimensionType: 'EVENT_DATA_PARAM_FIELD'
                },
                {
                    label: '上报时间',
                    value: 'createTime',
                    parameterType: 'STRING',
                    dimensionType: 'EVENT_DATA_PARAM_FIELD'
                },
                {
                    label: '操作系统',
                    value: 'operationSystem.name',
                    parameterType: 'STRING',
                    dimensionType: 'INTERNAL_DIMENSION'
                },
                {
                    label: '位置: 国家',
                    value: 'requestAddressInfo.country',
                    parameterType: 'STRING',
                    dimensionType: 'INTERNAL_DIMENSION'
                },
                {
                    label: '位置: 省份',
                    value: 'requestAddressInfo.province',
                    parameterType: 'STRING',
                    dimensionType: 'INTERNAL_DIMENSION'
                },
                {
                    label: '位置: 城市',
                    value: 'requestAddressInfo.city',
                    parameterType: 'STRING',
                    dimensionType: 'INTERNAL_DIMENSION'
                }
            ];
            this.options.dimensionOption.forEach(t => this.dimensionOptionMap.set(t.value, t))
            this.options.metricFinallyFormulaOption = deepCopy(this.options.metricCommonFormulaOption);
            trackParameterApi.queryTrackParameter({ eventId: this.reportSetting.eventId }).then(result => {
                if (result.code === 200) {
                    this.reportSetting.eventParameterList = result.data.result;
                    this.reportSetting.eventParameterList.forEach((t, index) => {
                        this.parameterMap.set(t.name, t)
                        let option = {
                            label: t.description,
                            value: t.name,
                            parameterType: t.type,
                            dimensionType: 'EVENT_REPORT_PARAM_FIELD'
                        }
                        this.options.dimensionOption.push(option);
                        this.dimensionOptionMap.set(option.value, option)
                        
                        let metricOption = {
                            label: t.description,
                            value: t.name,
                            type: t.type,
                            children: deepCopy(this.options.metricCommonFormulaOption)
                        }
                        if ('INTEGER' === t.type) {
                            metricOption.children.push(...deepCopy(this.options.metricNumericalEventParameterFormulaOption))
                        }
                        metricOption.children.push(...this.options.metricAddictionOption)
                        this.options.metricFinallyFormulaOption.push(metricOption);
                        
                        if (index === this.reportSetting.eventParameterList.length - 1) {
                            // if (this.reportSetting.dimensionSetting.argumentField) {
                            //     this.setDimensionInfo(this.reportSetting.dimensionSetting.argumentField)
                            // }
                        }
                    });
                }
            });
        },
        createNewMetricSetting() {
            let metricName = generateSortNextCharacter(this.metricConfig.metricNameList[this.metricConfig.metricNameList.length - 1]);
            this.metricConfig.metricNameList.push(metricName);
            this.reportSetting.metricSettingList.push({
                metricTitle: '指标名',
                formulaElementList: [],
                detailFormulaElementMapList: [],
                formula: '',
                maximumFractionDigits: 2,
                chartType: 'line',
                metricName: metricName,
                formulaNameList: []
            });
        },
        createNewDimensionSetting() {
            let lastDimensionIndex = 0;
            if (this.reportSetting.dimensionSettingList.length === 0) {
                lastDimensionIndex = 0;
            } else {
                lastDimensionIndex = this.reportSetting.dimensionSettingList[0].index + 1;
            }
            this.reportSetting.dimensionSettingList.push({
                dimensionTitle: undefined,
                dimensionTitleDescription: undefined,
                argumentField: undefined,
                dimensionType: undefined,
                dimensionIntervalRangeSet: [],
                sortType: 'NATURAL',
                index: lastDimensionIndex
            });
        },
        removeMetric(metricIndex) {
            this.reportSetting.metricSettingList.splice(metricIndex, 1);
            this.metricConfig.metricNameList.splice(metricIndex, 1);
        },
        removeDimension(index) {
            this.reportSetting.dimensionSettingList.splice(index, 1);
        },
        handleArithmeticOperatorChange(metricSetting, operator) {
            metricSetting.detailFormulaElementMapList.push({
                variableDescription: operator,
                formulaElement: operator,
                supportNumericalFilter: false,
                type: 'arithmeticOperator'
            })
        },
        handleMetricOtherOperatorChange(metricSetting, value) {
            this.options.metricOtherOption.forEach(t => {
                if (t.value === value) {
                    metricSetting.detailFormulaElementMapList.push({
                        variableDescription: t.label,
                        formulaElement: 0,
                        supportNumericalFilter: false,
                        type: 'inputValue'
                    })
                }
            })
        },
        handleMetricFormulaChange(metricSetting, formulaList) {
            if (formulaList.length === 0) {
                return;
            }
            if (formulaList.length === 1) {
                // 只包含公式 并不包含任何的筛选条件
                let formulaElement = formulaList[0];
                let formulaLabel = this.formulaOptionMap.get(formulaElement);
                metricSetting.detailFormulaElementMapList.push({
                    variableDescription: formulaLabel,
                    formulaElement: formulaElement,
                    supportNumericalFilter: false,
                    type: 'formula'
                })
            } else {
                let formulaName = generateSortNextCharacter(metricSetting.formulaNameList[metricSetting.formulaNameList.length - 1]);
                metricSetting.formulaNameList.push(formulaName);
                // 0位是字段名，1位是公式
                let fieldName = formulaList[0];
                let formulaElement = formulaList[1];
                let formulaLabel = this.formulaOptionMap.get(formulaElement);
                let parameter = this.parameterMap.get(fieldName);
                let fieldDesc = parameter.description;
                let variableDescription = `${fieldDesc} (${formulaLabel})`;
                
                metricSetting.detailFormulaElementMapList.push({
                    fieldName: parameter.name,
                    variableDescription: variableDescription,
                    formulaElement: formulaElement,
                    supportNumericalFilter: true,
                    fullExpress: parameter.type === 'INTEGER',
                    supportFilterOption: parameter.type === 'INTEGER' ? this.options.expressOption : this.options.stringExpressOption,
                    type: 'formula',
                    formulaName: formulaName
                });
            }
        },
        handleMetricParameterFilter(metricSetting, formulaElement) {
            this.eventDataConditionFilter.conditionConfig = {};
            this.eventDataConditionFilter.currentEditFormulaElement = formulaElement;
            
            if (!formulaElement.conditionalExpressionConfig) {
                if (formulaElement.conditionalExpression && formulaElement.conditionalExpression.operator) {
                    // 兼容旧版本
                    formulaElement.conditionalExpressionConfig = {
                        andOperator: true,
                        conditionList: [
                            formulaElement.conditionalExpression
                        ]
                    };
                }
            }
            this.eventDataConditionFilter.open = true;
            this.eventDataConditionFilter.conditionConfig = formulaElement.conditionalExpressionConfig;
        },
        handleClearFormulaElement(clearAll, metricSetting) {
            if (clearAll) {
                metricSetting.detailFormulaElementMapList = [];
                metricSetting.formulaNameList = [];
            } else {
                let lastDetailFormulaElement = metricSetting.detailFormulaElementMapList[metricSetting.detailFormulaElementMapList.length - 1];
                if (lastDetailFormulaElement.supportNumericalFilter) {
                    metricSetting.formulaNameList.splice(metricSetting.formulaNameList.length - 1, 1);
                }
                metricSetting.detailFormulaElementMapList.splice(metricSetting.detailFormulaElementMapList.length - 1, 1);
            }
        },
        handleExpressCondition(metricSetting, formulaElement) {
            let expressCondition = formulaElement.conditionalExpression;
            if (formulaElement.fullExpress) {
                if (!expressCondition.operator || !expressCondition.operand) {
                    message.error('条件表达式必须包含操作符和过滤值!')
                    expressCondition.operator = undefined
                    expressCondition.operand = undefined
                }
            }
        },
        setReportSettingParam(currentReportSetting) {
            let tableSetting = JSON.parse(currentReportSetting.tableSetting);
            let dimensionSetting = tableSetting.dimensionSetting;
            let metricSettingList = tableSetting.metricSettingList;
            let dimensionSettingList = tableSetting.dimensionSettingList;
            
            this.reportSetting = {
                eventId: undefined,
                name: undefined,
                metricSettingList: [],
                dimensionSettingList: [],
                eventParameterList: [],
                globalFilterExpress: tableSetting.globalFilterExpress
            };
            this.reportSetting.name = currentReportSetting.name;
            this.reportSetting.eventId = currentReportSetting.eventId + '';
            this.handleChangeEvent();
            
            // 设置维度
            if (dimensionSetting) {
                if (this.parameterMap.get(dimensionSetting.argumentField)) {
                    dimensionSetting.dimensionTitleDescription = this.parameterMap.get(dimensionSetting.argumentField).label;
                }
                this.reportSetting.dimensionSettingList.push(dimensionSetting);
            } else {
                if (dimensionSettingList) {
                    dimensionSettingList.forEach(t => {
                        if (this.parameterMap.get(t.argumentField)) {
                            t.dimensionTitleDescription = this.parameterMap.get(t.argumentField).label;
                        }
                        this.reportSetting.dimensionSettingList.push(t);
                    });
                }
            }
            
            // 设置指标
            this.reportSetting.metricSettingList = metricSettingList;
            this.reportSetting.metricSettingList.forEach(item => {
                if (!item.metricName) {
                    let metricName = generateSortNextCharacter(this.metricConfig.metricNameList[this.metricConfig.metricNameList.length - 1]);
                    this.metricConfig.metricNameList.push(metricName);
                    item.metricName = metricName;
                } else {
                    this.metricConfig.metricNameList.push(item.metricName);
                }
                if (!item.formulaNameList) {
                    item.formulaNameList = [];
                }
                
            });
        },
        
        handleCopyReportSetting() {
            this.openCopyReportSettingDialogStatus = true
        },
        handleCopyReportProjectChange(appId) {
            this.copyReportSetting.eventId = undefined
            this.copyReportSetting.trackReportSettingId = undefined
            // 查询所有的事件
            trackEventApi.queryTrackEvent({pageSize: 10000, projectAppId: appId}).then(result => {
                if (result.code === 200) {
                    this.copyReportSetting.trackEventList = result.data.result
                }
            })
        },
        handleCopyReportEventChange(eventId) {
            this.copyReportSetting.trackReportSettingMap = new Map
            this.copyReportSetting.trackReportSettingId = undefined
            // 查询所有的事件
            trackReportSettingApi.query({pageSize: 10000, eventId: eventId}).then(result => {
                if (result.code === 200) {
                    this.copyReportSetting.trackReportSettingList = result.data.result
                    this.copyReportSetting.trackReportSettingList.forEach(t => this.copyReportSetting.trackReportSettingMap.set(t.id, t))
                }
            })
        },
        handleExecuteCopyReportSetting() {
            let obj = this
            let trackReportSetting = this.copyReportSetting.trackReportSettingMap.get(this.copyReportSetting.trackReportSettingId)
            this.$modal.confirm(`是否使用 ${trackReportSetting.name} 报表的所有设置，此操作会覆盖当前弹窗的所有报表设置!`).then(function() {
                obj.setReportSettingParam(trackReportSetting)
                obj.openCopyReportSettingDialogStatus = false
            }).then((result) => {
                obj.openCopyReportSettingDialogStatus = false
            }).catch(() => {
            
            });
        },
        handleCopyReportClose() {
            this.copyReportSetting = {
                projectAppId: undefined,
                eventId: undefined,
                trackReportSettingId: undefined,
                
                trackEventList: [],
                trackReportSettingList: [],
                trackReportSettingMap: new Map
            }
        },
        handleTestTrackReport() {
            this.packageReportSetting(() => {
                this.showTrackReportChart.trackReportSettingJson = JSON.stringify(this.reportSetting)
                this.showTrackReportChart.openTrackReportDialogStatus = true
            })
        },
        handleCloseTrackReportChart() {
            this.showTrackReportChart.trackReportSettingJson = undefined
            this.showTrackReportChart.reportSettingInfo = {}
        },
        handleClickTargetEvent(data) {
            let eventId = data.eventId;
            this.$router.push(`/trackAnalyse/eventAnalyse/${this.queryParams.projectAppId}/${eventId}`);
        },
        handleViewSingle(data) {
            let eventId = data.eventId;
            this.$router.push(`/trackAnalyse/singleEventAnalyse/${this.queryParams.projectAppId}/${eventId}/${data.id}`);
        },
        handleCascaderVisibleChange(value) {
            console.log(this.cascaderValueTemp);
        },
        handleDimensionArgumentFieldChange(dimensionSetting) {
            this.setDimensionInfo(dimensionSetting.argumentField, dimensionSetting);
        },
        handleGetCondition(conditionConfig) {
            this.eventDataConditionFilter.currentEditFormulaElement.conditionalExpressionConfig = conditionConfig;
        },
        handleGlobalFilterCondition(conditionConfig) {
            this.reportSetting.globalFilterExpress = conditionConfig;
        }
    }
};
</script>
<style lang='css'>
.formula-element {
    margin-right: 5px;
    margin-top: .5rem;
}

.formula-filter {
    border-left: 1px solid #409EFF;
    margin-left: 3px;
    padding-left: 3px;
    cursor: pointer;
}

.formula-box {
    border: 1px solid #409EFF;
    padding: 10px;
    border-radius: 4px;
}

.formula-input {
    background-color: rgba(245, 108, 108, 0.04);
    padding: 5px;
    border-radius: 4px;
}
</style>
